module.exports = __webpack_public_path__ + "static/img/bg1.5291014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.jpg
// module id = mg/2
// module chunks = 1